<template>
  <div class="b-block b-block--md-pad relative overflow-hidden">
    <Loader v-if="isLoading"></Loader>
    <Alert
      v-if="!isLoading && errorMsgs.length"
      key="submit-errors"
      dismiss-by-native=""
      type="danger"
      :messages="errorMsgs"
      @close="removeErrors"></Alert>
    <div class="b-block__seperator--el">
      <div class="b-block__title--md">{{ dictionary.choicesTitle }}</div>

      <!-- Send new card -->
      <div class="b-block__settings">
        <div class="b-block__settings__left-col">
          <div class="b-block__settings__title">
            {{ dictionary.membershipCardTitle }}
          </div>
          <div class="b-block__settings__text">
            {{ dictionary.membershipCardDescription }}
          </div>
        </div>
        <div class="b-block__settings__right-col">
          <Wallet :items="wallet"></Wallet>
          <!-- <a class="b-block__send-card-btn" :href="configuration.getFamilyPassUrl"><span>{{ dictionary.buttonSendMembershipCardText }}</span></a> -->
        </div>
      </div>
    </div>

    <!-- separator -->
    <hr class="b-block__seperator" />
    <div class="b-block__settings">
      <div class="b-block__settings__left-col">
        <div class="b-block__settings__title">
          {{ dictionary.membershipCardPdf }}
        </div>
        <div class="b-block__settings__text">
          {{ dictionary.membershipCardPdfDescription }}
        </div>
      </div>
      <div class="b-block__settings__right-col">
        <a
          class="b-block__card-pdf"
          :href="configuration.pdfCardUrl"
          rel="noopener noreferrer"
          target="_blank">
          <span>{{ dictionary.membershipCardPdfBtn }}</span>
        </a>
      </div>
    </div>

    <!-- <hr  v-if="isFamilyRenewal" class="b-block__seperator"/>

    <div v-if="isFamilyRenewal" class="b-block__settings">
        <div class="b-block__settings__left-col">
          <div class="b-block__settings__title">
            {{ dictionary.accountRenewRequestTitle }}
          </div>
          <div class="b-block__settings__text">
            {{ dictionary.accountRenewRequestDescription }}
          </div>
        </div>
        <div class="b-block__settings__right-col">
          <a class="b-block__send-card-btn" :href="configuration.RenewFamilyUrl"><span>{{ dictionary.buttonAccountRenewRequestText }}</span></a>
        </div>
      </div> -->

    <!-- separator -->
    <hr class="b-block__seperator" />
    <!-- Delete account -->
    <div class="b-block__settings">
      <div class="b-block__settings__right-col">
        <div class="b-block__settings__title">
          {{ dictionary.accountDeleteRequestTitle }}
        </div>
        <div class="b-block__settings__text">
          {{ dictionary.accountDeletetRequestDescription }}
        </div>
      </div>
      <div class="b-block__settings__right-col">
        <button
          type="submit"
          :disabled="isLoading || accountDeleteRequestConfirmed"
          class="b-block__delete-acc-btn"
          @click="() => toggleConfirmModal(true)">
          {{ dictionary.buttonAccountDeleteRequestText }}
        </button>
      </div>
    </div>

    <ModalOverlay
      v-model="showSuccessModal"
      background-class="b-pop-up--alert-success b-pop-up__holder"
      header-background-class="b-pop-up__header">
      <template #header>
        <div class="b-pop-up__header__title">
          {{ dictionary.submitSuccessHeader }}
        </div>
      </template>
      <template #body>
        <div class="b-pop-up__alert-success__content">
          <div
            class="b-pop-up__alert-success__icon b-pop-up__alert-success__icon--success"></div>
          <div class="b-pop-up__alert-success__content__container">
            <div class="b-pop-up__alert-success__title">
              {{ dictionary.submitSuccessTitle }}
            </div>
            <div class="b-pop-up__alert-success__text">
              {{ dictionary.submitSuccessContent }}
            </div>
          </div>
        </div>
      </template>
    </ModalOverlay>

    <ModalOverlay
      v-model="showConfirmModal"
      background-class="b-pop-up--alert-success b-pop-up__holder"
      header-background-class="b-pop-up__header">
      <template #header>
        <div class="b-pop-up__header__title">
          {{ dictionary.submitConfirmHeader }}
        </div>
      </template>
      <template #body>
        <div class="b-pop-up__alert-success__content">
          <div class="b-pop-up__alert-success__content__container">
            <div class="b-pop-up__alert-success__title">
              {{ dictionary.submitConfirmTitle }}
            </div>
            <div class="b-pop-up__alert-success__text">
              {{ dictionary.submitConfirmContent }}
            </div>
            <div class="b-pop-up__alert-success__btn-area">
              <button
                type="button"
                class="b-pop-up__alert-success__cta"
                @click="accountDeleteRequest">
                {{ dictionary.submitConfirm }}
              </button>
              <button
                type="button"
                class="btn-primary-orange btn--block"
                @click="() => toggleConfirmModal(false)">
                <span>{{ dictionary.submitConfirmClose }}</span>
              </button>
            </div>
          </div>
        </div>
      </template>
    </ModalOverlay>
  </div>
</template>

<script>
import * as lib from './../../lib/lib'
import Loader from './../components/Shared/Loader.vue'
import Alert from './../components/Shared/Alert.vue'
import Wallet from '../components/Wallet.vue'
import ModalOverlay from './../components/ModalOverlay.vue'
import postRequestHandler from '../../lib/postRequestHandler'
import getErrorMessage from '../../lib/getErrorMessage'

export default {
  components: { Loader, ModalOverlay, Alert, Wallet },
  data() {
    return {
      isLoading: true,
      errorMsgs: [],
      showSuccessModal: false,
      showConfirmModal: false,
      accountDeleteRequestConfirmed: false,
      membershipCardAction: '',
      isFamilyClub: false,
      isFamilyRenewal: false,
      wallet: [],
    }
  },

  computed: {
    newPasswordHasValue() {
      return typeof this.newPassword === 'string' && this.newPassword.length > 0
    },
    submitButtonIsDisabled() {
      return this.isLoading || this.v$.$invalid
    },
  },

  mounted() {
    const { isFamilyClub, isFamilyRenewal, wallet } = lib.getData(
      'profileMembershipAppData'
    )
    this.isFamilyClub = isFamilyClub
    this.isFamilyRenewal = isFamilyRenewal
    this.wallet = wallet
    lib.checkCaptcha(() => (this.isLoading = false))
  },

  methods: {
    removeErrors() {
      this.errorMsgs = []
    },
    toggleSuccessModal(show) {
      this.showSuccessModal = show
    },
    toggleConfirmModal(show) {
      this.showConfirmModal = show
    },

    accountDeleteRequest() {
      this.membershipCardAction = 'askForDelete'
      this.showConfirmModal = false
      this.onAskForDelete()
    },

    async onAskForDelete() {
      if (this.isLoading) {
        return false
      }

      this.removeErrors()
      this.isLoading = true

      const postData = {}

      await postRequestHandler({
        postData,
        endpoint: this.configuration.endpointAskForDeleteData,
        successCallback: this.handleSuccess,
        errorCallback: this.handleError,
        refreshTokenHandler: this.configuration.refresh,
        captchaAction: this.configuration.captchaActionDelete,
      })
    },

    handleSuccess(response) {
      this.isLoading = false
      this.errorMsgs = []
      if (this.membershipCardAction === 'send') {
        this.toggleSuccessModal(true)
      }
      if (this.membershipCardAction === 'askForDelete') {
        this.accountDeleteRequestConfirmed = true

        const { redirectUrl } = response.data

        if (redirectUrl) {
          window.location.assign(redirectUrl)
        }
      }
    },

    async handleError(messages) {
      this.isLoading = false

      this.errorMsgs = getErrorMessage(
        messages,
        this.dictionary.defaultErrorMessage
      )

      await this.$nextTick()
      lib.scrollToError()
    },
  },
}
</script>
